// @flow
import { createSelector } from "reselect"
import { SplitsterClient } from "splitster"

export const splitsterSelector = (state: { splitster: SplitsterClient }) => state.splitster

export const createSplitsterValueSelector = (testId: string) =>
  // $FlowFixMe
  createSelector(
    [splitsterSelector],
    splitster => splitster.get(testId).value,
  )
